import 'jspolyfill-array.prototype.find';
import smoothscroll from 'smoothscroll-polyfill';

import $ from 'jquery';
import processInclude from './util';

import { installAjaxHandlers } from './components/ajax';
import * as header from './components/header';
import * as productTile from './search/productTile';
import * as initAddressForms from './components/addressForm';
import bodyScroll from './components/bodyScroll';
import backToTop from './components/backToTop';
import { initForms } from './components/forms';
import initRecaptcha from './components/recaptcha';
import * as intelligentReach from './search/intelligentReach';
import stickyHeaderScroll from './components/stickyHeaderScroll';
import validateInput from './components/validateInput';
import addToBagRecommendations from './components/addToBagRecommendation';
import * as transparentHeader from './components/transparentHeader';
import * as mobileSearch from './components/mobileSearch';
import * as globaleBase from './globale/globale';
import sqvOverlay from './product/sqvOverlay';

import '~base';

installAjaxHandlers();

$(document).ready(() => {
  processInclude(header);
  processInclude(productTile);
  processInclude(initAddressForms);
  processInclude(backToTop);
  processInclude(bodyScroll);
  processInclude(initForms);
  processInclude(initRecaptcha);
  processInclude(intelligentReach);
  processInclude(stickyHeaderScroll);
  processInclude(validateInput);
  processInclude(addToBagRecommendations);
  processInclude(transparentHeader);
  processInclude(mobileSearch);
  processInclude(sqvOverlay);

  processInclude(globaleBase);
  smoothscroll.polyfill();
});
